import React from "react";

const UserRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 7.42108C9.37249 7.42108 10.4851 6.29716 10.4851 4.91074C10.4851 3.52431 9.37249 2.40039 8 2.40039C6.62751 2.40039 5.51489 3.52431 5.51489 4.91074C5.51489 6.29716 6.62751 7.42108 8 7.42108Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.0602 13.6001H11.9399C12.8131 13.6001 13.4856 12.8417 13.0779 12.0618C12.4781 10.9145 11.1106 9.54492 8.00005 9.54492C4.88946 9.54492 3.52201 10.9145 2.9222 12.0618C2.51444 12.8417 3.18703 13.6001 4.0602 13.6001Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(UserRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;